var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative font-sans antialiased" },
    [
      _vm.patientError
        ? _c("div", { staticClass: "absolute pin-t pin-r mt-10 mr-10" }, [
            _c(
              "div",
              {
                staticClass:
                  "bg-red-light shadow border border-red-light text-white px-4 py-3 rounded relative"
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("span", {
                  staticClass: "font-semibold",
                  domProps: { textContent: _vm._s(_vm.patientError) }
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("router-view", {
        staticClass: "min-h-(screen-footer-sm) md:min-h-(screen-footer-md)"
      }),
      _vm._v(" "),
      _c(
        "footer",
        { staticClass: "py-12 bg-footer text-white", attrs: { id: "footer" } },
        [
          _c("div", { staticClass: "max-w-md mx-auto px-6" }, [
            _c(
              "div",
              { staticClass: "flex items-top flex-wrap md:justify-between" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "w-full md:w-auto flex flex-col justify-center md:justify-start"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "flex justify-center md:justify-start mb-4"
                      },
                      [
                        _c("router-link", { attrs: { to: { path: "/" } } }, [
                          _c("img", {
                            staticClass: "h-4",
                            attrs: {
                              src: "/static/img/tooddoc.png",
                              alt: "Tooddoc"
                            }
                          })
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex justify-center md:flex-col md:justify-start mb-8 md:mb-0"
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "transition md:opacity-50 hover:opacity-100 mx-2 md:mx-0 md:mb-4",
                            attrs: {
                              href: _vm.$t("play_store_uri"),
                              target: "_blank"
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "h-10",
                              attrs: {
                                src: "/static/img/play_store_hover.svg",
                                alt: "Get it on Google Play"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass:
                              "transition md:opacity-50 hover:opacity-100 mx-2 md:mx-0",
                            attrs: {
                              href: _vm.$t("app_store_uri"),
                              target: "_blank"
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "h-10",
                              attrs: {
                                src: "/static/img/app_store_hover.svg",
                                alt: "Get it on the App Store"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "w-full md:w-auto flex md:flex-col items-center justify-center md:justify-start md:items-start md:text-left mb-8 md:mb-0"
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass:
                          "text-white hover:underline text-xs font-semibold md:mb-4",
                        attrs: { href: _vm.$t("public_site_uri") }
                      },
                      [_vm._v(_vm._s(_vm.$t("public_site_label")))]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "mx-2 md:hidden" }, [
                      _vm._v("-")
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "text-white hover:underline text-xs font-semibold md:mb-4",
                        attrs: { href: _vm.$t("contact_uri") }
                      },
                      [_vm._v(_vm._s(_vm.$t("contact_label")))]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "mx-2 md:hidden" }, [
                      _vm._v("-")
                    ]),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        staticClass:
                          "text-white hover:underline text-xs font-semibold md:mb-4",
                        attrs: { to: { name: "doctor.dashboard" } }
                      },
                      [_vm._v(_vm._s(_vm.$t("i_am_a_dentist_label")))]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "hidden md:flex w-auto flex-col text-left" },
                  [
                    _c(
                      "a",
                      {
                        staticClass:
                          "text-white hover:underline text-xs font-semibold mb-4",
                        attrs: { href: _vm.$t("terms_uri") }
                      },
                      [_vm._v(_vm._s(_vm.$t("terms_label")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "text-white hover:underline text-xs font-semibold mb-4",
                        attrs: { href: _vm.$t("privacy_policy_uri") }
                      },
                      [_vm._v(_vm._s(_vm.$t("privacy_policy_label")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "text-white hover:underline text-xs font-semibold mb-4",
                        attrs: { href: _vm.$t("cookie_policy_uri") }
                      },
                      [_vm._v(_vm._s(_vm.$t("cookie_policy_label")))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex md:hidden w-full md:w-auto items-center justify-center text-center"
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass:
                          "text-white hover:underline text-xs font-semibold",
                        attrs: { href: _vm.$t("terms_uri") }
                      },
                      [_vm._v(_vm._s(_vm.$t("terms_label")))]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "mx-2" }, [_vm._v("-")]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "text-white hover:underline text-xs font-semibold",
                        attrs: { href: _vm.$t("privacy_policy_uri") }
                      },
                      [_vm._v(_vm._s(_vm.$t("privacy_policy_label")))]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "mx-2" }, [_vm._v("-")]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "text-white hover:underline text-xs font-semibold",
                        attrs: { href: _vm.$t("cookie_policy_uri") }
                      },
                      [_vm._v(_vm._s(_vm.$t("cookie_policy_label")))]
                    )
                  ]
                )
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.showCookieNotification
        ? _c("div", { staticClass: "fixed pin-x pin-b mb-4" }, [
            _c(
              "div",
              {
                staticClass:
                  "flex items-center justify-between rounded bg-blue text-white max-w-sm mx-auto px-4 py-3"
              },
              [
                _c("span", {
                  domProps: {
                    textContent: _vm._s(_vm.$t("cookie_notification"))
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "text-blue-lighter hover:text-blue-lightest",
                    on: {
                      click: function($event) {
                        return _vm.consentCookies()
                      }
                    }
                  },
                  [_vm._m(1)]
                )
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-1 text-lg" }, [
      _c("i", { staticClass: "mdi mdi-alert-circle-outline" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6de776e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6de776e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/PatientLayout.vue
// module id = 795
// module chunks = 1